export interface Song {
    id: number,
    gid: string,
    typeId: string,
    userId: string,
    words1: string,
    words2: string,
    words3: string,
    words4: string,
    words5: string,
    point:  number,
    lv:     number,
    created: string,
}

export class Inc {
    //static readonly grades = [
    //    "3+","10+","50+","100+","500+","1000+","5000+","10000+",
    //]
    static readonly defaultSong = ()=>{
        const song:Song = {
            id: 0,
            gid: "",
            typeId: "",
            userId: "",
            words1: "",
            words2: "",
            words3: "",
            words4: "",
            words5: "",
            point:  0,
            lv: 0,
            created: "",
        }
        return song;
    }
}